import React, { useEffect, useReducer } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reducer, { defaultState, setEditDataCreator, updateFieldCreator } from './reducer';
import {
  setMaCisEditErrorsCreator,
  updateMaCisCreator,
} from '../../../../../store/actionsCreators';
import { globalPropTypes } from 'helpers';
import EditCertificateHolder from '../../../../../shared/Cis/CertificateHolders/Edit/EditCertificateHolder';

const EditIpmaCertificateHolder = ({
  certificateHolder,
  errors,
  updateCertificateHolder,
  removeError
}) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  useEffect(() => {
    if (certificateHolder) {
      dispatch(setEditDataCreator(certificateHolder));
    }
  }, [certificateHolder]);

  return (
    <EditCertificateHolder 
    state={state}
    dispatch={dispatch}
    updateFieldCreator={updateFieldCreator}
    errors={errors}
    updateCertificateHolder={updateCertificateHolder}
    removeError={removeError}
    type="ma"
    />
  )
};

EditIpmaCertificateHolder.propTypes = {
  certificateHolder: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    title: PropTypes.string,
    middleName: PropTypes.string,
    birthDate: PropTypes.any,
    status: PropTypes.number,
  }),
  errors: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    title: PropTypes.string,
    middleName: PropTypes.string,
    birthDate: PropTypes.string,
    status: PropTypes.string
  }),
  certificationBodies: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  updateCertificateHolder: PropTypes.func.isRequired,
  loadCertificationBodies: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
};

EditIpmaCertificateHolder.defaultProps = {
  errors: {},
};

const mapStateToProps = ({ ma }) => ({
  errors: ma.cis.certificateHolders.editErrors,
  certificateHolder: ma.cis.certificateHolders.profile,
});

const mapDispatchToProps = (dispatch) => ({
  updateCertificateHolder: (id, payload, history) =>
    dispatch(updateMaCisCreator(id, 'certificateHolders', payload, history)),
  removeError: (payload) => dispatch(setMaCisEditErrorsCreator('certificateHolders', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditIpmaCertificateHolder);
